import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import EmpresaController from "@/shared/controllers/empresa/empresaController";
import ProdutoController from "@/shared/controllers/produto/produtoController";
import FiltroVendasPorPeriodo from "@/shared/view-models/Filtros/FiltroVendasPorPeriodo";
import PedidoController from "@/shared/controllers/pedido/PedidoController";

const name = 'VendasPeriodo'

export default {
  name,

  components:{
    "g-button": gButton,
    "g-card": gCard,
  },

  props: { },
  watch: {
    novoFiltroVendas() {
      if (this.novoFiltroVendas.ClienteId == (undefined || null))
      {
        this.ClienteAgrupadorAtiva = true;
      }
     }
  },
  mounted() {
    this.UnidadeArray = EmpresaController.getEmpresasAtivas().EmpresaArray;
    this.popularDropDownEmpresa();
    this.mitt.on('trocaEmpresaRepresentante', () => {
      this.atualizaEmpresaRepresentante()
    })
    this.novoFiltroVendas.RepresentanteId = this.$store.state.representanteSelecionadoId;
    
  },

  updated() { },

  data() {
    return {
        ClienteAgrupadorAtiva: true,
        ClienteArray: [],
        EmpresaArray: [],
        ClienteId: null,
        ClienteSelecionado: null,
        grid: true,
        novoFiltroVendas: new FiltroVendasPorPeriodo(),
        UnidadeArray: [],
        ProdutoArray: [],
        RepresentantesArray:[],
        RepresentanteSelecionado: null,
        VendasPorPeriodoArray: [],
        OrdenacaoArray: [{ value: "data", text: "Data e Hora do Pedido" },{ value: "numero", text: "Número do Pedido" },],

        emLinhaArray: [
          { value: true, campo: "Sim" },
          { value: false, campo: "Não" },
          ],

        Colunas : [
          {field: 'codigoEnumeroparcela', header: 'Pedido/Parcela', width: '50px', ordena: true},
          {field: 'dataInclusaoFormatada', header: 'Data da Venda', width: '160px', ordena: true , ordenacao:'inclusao'},
          {field: 'codigoProdutoNomeProduto', header: 'Produto', width: '350px', ordena: true},
          {field: 'numeroQuantidadeTotalFormatada', header: 'Quantidade', width: '160px', ordena: true, alinha: 'right'},
          {field: 'valorPrecoVendaFormatada', header: 'Preço de Venda', width: '160px', ordena: true, alinha: 'right'},
          {field: 'porcentagemComissaoVendaFormatada', header: '% Comissão', width: '160px', ordena: true, alinha: 'right'},
        ],

        Filtro: {
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'codigo': {value: null, matchMode:this.filtros.CONTAINS},
          'campoCliente_Pedido': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
          'dataInclusaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'quantidadeExpedida': {value: null, matchMode: this.filtros.CONTAINS},
          'valorPrecoVenda': {value: null, matchMode: this.filtros.CONTAINS},
          'comissao': {value: null, matchMode: this.filtros.CONTAINS},
        },
    }
  },

  methods: {
    getProduto(pesquisa) {
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        ProdutoController.GetProdutoDropDownByPesquisaRepresentanteEmpresa(pesquisa, this.$store.state.representanteSelecionadoId, this.novoFiltroVendas.UnidadeId).requisicao
        .then((res) => {
          this.ProdutoArray = res.data.data
        })
        .catch(() => {
        })
      }, 1000);
    },
    Buscar() {
        this.GetVendasPorPeriodoByFiltro()
    },

    detalhesPedidoVenda(data) {
      const rotaNovaAbaURL = this.$router.resolve({
        path: `pedido-em-andamento-fluxo/${data.pedidoId}/detalhes-pedido-andamento`
      }).href;
      
      window.open(rotaNovaAbaURL, '_blank');
    },
    ativaClienteAgrupador() {
      this.ClienteAgrupadorAtiva = false;
    },
    GetVendasPorPeriodoByFiltro() {
      this.$isLoading(true)
      if(this.DataFinalUltimaVenda != undefined) {
        let dataFinal = this.DataFinalUltimaVenda.split('/')
        this.novoFiltroVendas.DataFinalUltimaVenda = new Date(dataFinal[2], dataFinal[1]-1, dataFinal[0])
      }

      if(this.DataInicioUltimaVenda != undefined ) {
        let dataInicio = this.DataInicioUltimaVenda.split('/')

        this.novoFiltroVendas.DataInicioUltimaVenda = new Date(dataInicio[2], dataInicio[1]-1, dataInicio[0])
      }


      PedidoController.GetVendasPorPeriodoByFiltro(this.novoFiltroVendas).requisicao
      .then(response => {
        this.grid = false
        this.VendasPorPeriodoArray = response.data.data
      })
      .finally(() => {
        this.$isLoading(false)
      })
    },

    atualizaEmpresaRepresentante() {
      this.novoFiltroVendas.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.novoFiltroVendas.UnidadeId = this.$store.state.empresaSelecionadaId;
    },

    buscarClientes(event){
      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.ClienteArray = ClienteController.GetAllClientesByEmpresaIdEFiltro(this.novoFiltroVendas.UnidadeId, event).ClientesArray;
      }, 1000);
    },

    limpar(){
      this.novoFiltroVendas = new FiltroVendasPorPeriodo();
      this.ClienteArray = []
      this.DataInicioUltimaVenda = null
      this.DataFinalUltimaVenda = null
      EmpresaController.getEmpresasAtivas().requisicao
      .then(response => {
        this.UnidadeArray = response.data.data
        this.atualizaEmpresaRepresentante()
      })
      this.mitt.on('trocaEmpresaRepresentante', () => {
        this.atualizaEmpresaRepresentante()
      })
    },
    popularDropDownEmpresa(){
      this.EmpresaArray = this.$store.state.EmpresaArray;
      this.atualizaEmpresaRepresentante()
      },
  },

  computed: { }
};